/**
 * TKP-64 / K4.1 — süreç bazında kategori, aynı verinin başka bir süreçteki bayrağıyla çelişince backend kaydeder ve cevapta
 * `warnings[]` döner; UI bunları kullanıcıya uyarı olarak gösterir (engelleme yok). Saf: `t` dışarıdan.
 *
 * TKP-128 — eski metin ("Bu süreçte özel nitelikli veri olarak işaretli, X sürecinde değil. Kayıt yapıldı.") bayrak ve
 * süreç adıyla kurulan, anlaşılması zor bir cümleydi. Kullanıcının istediği tek, net açıklama gösterilir: değişikliğin
 * kapsamı yalnız bu süreç; öteki süreçlerdeki aynı isimli veriler etkilenmedi. Uyarı ne kadar kardeş süreçten gelirse
 * gelsin mesaj BİR kez gösterilir.
 */
export const categoryWarningMessages = (warnings, t) => (Array.isArray(warnings) && warnings.length ? [t("process-data.category-scope-notice")] : []);

/**
 * Bildirimdeki koşul: "kategori değiştirildiğinde VE aynı isimli veri başka süreçte de yer aldığında". Backend bayrak
 * çelişkisinde `warnings[]`, her durumda da verinin başka kaç süreçte olduğunu (`otherProcesses`) döner — açıklama
 * bayraktan değil kapsamdan söz ettiği için ikisinden biri yeter.
 */
export const categoryScopeMessages = (data, t) =>
  (Array.isArray(data && data.warnings) && data.warnings.length) || Number(data && data.otherProcesses) > 0 ? [t("process-data.category-scope-notice")] : [];

/** Kategori bu kayıtta gerçekten değişti mi — `null`/`undefined` "override yok" demek. */
export const categoryChanged = (before, after) => String((before && before._id) || before || "") !== String((after && after._id) || after || "");

/**
 * Backend uyarıyı DURUMA göre döner (çelişki varsa her kayıtta), değişikliğe göre değil. Bu yüzden eskiden kategori
 * değiştirilmiş bir veride kaynak/not güncellemek bile her kardeş süreç için ayrı sarı kutu açıyordu. Mesaj
 * "kategorisi güncellenmiştir" dediği için yalnız kategori O KAYITTA değiştiyse gösterilir.
 */
export const showCategoryWarnings = (vm, response, { changed = true } = {}) => {
  if (!changed) return [];
  const messages = categoryScopeMessages(response && response.data, (k, p) => vm.$t(k, p));
  messages.forEach((m) => vm.$toast.warning(m));
  return messages;
};
